var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useMemo, useState, Fragment } from 'react';
import { Collapse, UnmountClosed } from 'react-collapse';
import { ContentContainer, FooterSection, HeaderSection } from './collapsible-styles';
import { getBodyContent, getFooterContent, getHeaderContent, isFunction } from './utils';
var Collapsible = function (_a) {
    var children = _a.children, useUnmountClosed = _a.useUnmountClosed, transitionTime = _a.transitionTime, _b = _a.initialOpen, initialOpen = _b === void 0 ? false : _b, restProps = __rest(_a, ["children", "useUnmountClosed", "transitionTime", "initialOpen"]);
    var _c = useState(initialOpen), isOpened = _c[0], updateIsOpened = _c[1];
    var toggleIsOpened = useCallback(function () { return updateIsOpened(!isOpened); }, [isOpened]);
    var childrenContent = children;
    if (isFunction(children) && children instanceof Function) {
        var result = children && children({ isOpened: isOpened });
        childrenContent = result && result.props && result.props.children;
    }
    var headerContent = useMemo(function () { return getHeaderContent(childrenContent); }, [childrenContent]);
    var bodyContent = useMemo(function () { return getBodyContent(childrenContent); }, [childrenContent]);
    var footerContent = useMemo(function () { return getFooterContent(childrenContent); }, [childrenContent]);
    if (useUnmountClosed) {
        return (React.createElement(Fragment, null,
            React.createElement(HeaderSection, { onClick: toggleIsOpened }, headerContent),
            React.createElement(ContentContainer, { transitionTime: transitionTime },
                React.createElement(UnmountClosed, __assign({ isOpened: isOpened }, restProps), bodyContent)),
            React.createElement(FooterSection, { onClick: toggleIsOpened }, footerContent)));
    }
    return (React.createElement(Fragment, null,
        React.createElement(HeaderSection, { onClick: toggleIsOpened }, headerContent),
        React.createElement(ContentContainer, { transitionTime: transitionTime },
            React.createElement(Collapse, __assign({ isOpened: isOpened }, restProps), bodyContent)),
        React.createElement(FooterSection, { onClick: toggleIsOpened }, footerContent)));
};
export default Collapsible;
